import React, { Component } from 'react';
import Web3 from 'web3'
import CryptoLotto from '../abis/CryptoLotto.json'
import logo from '../logo.png';
import './App.css';

import painting_01 from '../imgs/01.jpg';
import painting_02 from '../imgs/02.jpg';
import painting_03 from '../imgs/03.jpg';
import painting_04 from '../imgs/04.jpg';
import painting_05 from '../imgs/05.jpg';
import painting_06 from '../imgs/06.jpg';
import painting_07 from '../imgs/07.jpg';
import painting_08 from '../imgs/08.jpg';
import painting_09 from '../imgs/09.jpg';
import painting_10 from '../imgs/10.jpg';


////////////////////////////////////////////////////////////////////////////////////////

let img_srcs = [painting_01, painting_02, painting_03, painting_04, painting_05, painting_06, painting_07, painting_08, painting_09, painting_10];
let intros = ["Vincent van Gogh, “Self-Portrait”, 1889",
              "Henri Rousseau, “Tropical Forest with Monkeys”, 1844–1910",
              "Paul Cézanne, “Flowers in a Rococo Vase”, 1876",
              "George Stubbs “White Poodle in a Punt”, 1780",
              "Rembrandt van Rijn, “Self-Portrait”, 1659",
              "Giovanni Battista Tiepolo, “Bacchus and Ariadne”, 1696–1770",
              "Henri de Toulouse-Lautrec, “Alfred la Guigne”, 1894",
              "Edouard Vuillard, “Place Vintimille”, 1911",
              "Claude Monet, “The Japanese Footbridge”, 1899",
              "Gilbert Stuart, “Eleanor Parke Custis Lewis”, 1804",
  ];

class App extends Component {

  async componentWillMount() {
    await this.loadWeb3()
    if(this.state.Web3Status)
      await this.loadBlockchainData()
  }

  componentDidMount() {
    this.interval = setInterval(() => { 
      if (this.state.Lotto != null){
        this.updateContractInfo()
        //console.log('time update')
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async loadBlockchainData() {
    const web3 = window.web3
    const accounts = await web3.eth.getAccounts()
    console.log('account address: ' + accounts)
    this.setState({ account: accounts[0] })

    const networkId = await web3.eth.net.getId()
    const networkData = CryptoLotto.networks[networkId]
    if(networkData) {
      try{
          const lotto = web3.eth.Contract(CryptoLotto.abi, networkData.address)
          this.setState({Lotto: lotto})
          console.log('Lotto address: ' + lotto.address)
          const itemNumber = await lotto.methods.ITEM_NUMBER().call()
          console.log('item number: ' + itemNumber.toString())
          this.setState({ItemNumber: Number(itemNumber.toString())})
          const drawPrice = await lotto.methods.MinDrawValue().call()
          console.log('draw price: ' + drawPrice.toString())
          this.setState({DrawPrice: Number(drawPrice.toString())})
          const sponsorPrice = await lotto.methods.MinSponsorValue().call()
          console.log('sponsor price: ' + sponsorPrice.toString())
          this.setState({SponsorPrice: Number(sponsorPrice.toString())})

          for (let i=0; i<Number(itemNumber); i++) {
            //console.log('item ' + i + ' is owned: ' + isOwned.toString())
            const sponsorable = await lotto.methods.sponsorable(i).call()
            const drawable = await lotto.methods.drawable(i).call()
            const reward = await lotto.methods.checkReward(i).call()
            const txNum = await lotto.methods.getTxNum(i).call()
            const difficulty = await lotto.methods.getDifficulty(i).call()
            const isOwner = await lotto.methods.isOwner(accounts[0], i).call()
            
            this.setState({
              Contract_info: [ ...this.state.Contract_info, {
                TxNum: Number(txNum.toString()),
                Sponsorable: sponsorable.toString(),
                Drawable: drawable.toString(),
                Reward: Number(reward.toString()),
                Difficulty: Number(difficulty.toString()),
                IsOwner: isOwner.toString(),
              }],
            });
          }
          this.setState({ContractStatus: true})
        }catch(e){
          this.setState({ContractStatus: false})
          console.error(e.message);
          window.alert('Sorry for contract retrieval error.')
        }
      
    } else {
      this.setState({ContractStatus: false})
      window.alert('Contract is not deployed to detected network.')
    }
  }



  async loadWeb3() {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum)
      await window.ethereum.enable()
      this.setState({Web3Status: true})
    }
    else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider)
      this.setState({Web3Status: true})
    }
    else {
      this.setState({Web3Status: false})
      window.alert('Non-Ethereum browser detected. You should consider trying MetaMask!')
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      Web3Status: false,
      ContractStatus: false,
      account: '',
      ItemNumber: 0,
      Lotto: null,      
      DrawPrice: 0,
      SponsorPrice: 0,
      Contract_info: [],
      Message: '',
      MessageID: 0, 


    }
  }

  async btnDrawClick(index){
    console.log(index + " is clicked") //
    this.setState({Message:''})
    this.setState({MessageID: index})

    if (!this.state.ContractStatus){
      window.alert('Contract is not ready! Please wait or check errors.')
      return
    }

    if (this.state.Lotto != null){
      let drawable = this.state.Contract_info[index].Drawable //price in wei
      if (drawable === 'false'){
        window.alert('Sorry for no funds to draw. You could become dealer first to start the draw!')
        return
      }

      if (window.confirm('Are you sure to draw with < ' + intros[index] + '> ?')){ 
        let reward = this.state.Contract_info[index].Reward //price in wei
        console.log('reward ' + index + ': ' + reward * 1.0e-18)
        let drawPrice = this.state.DrawPrice // in wei
        console.log('draw price ' + index + ': ' + drawPrice * 1.0e-18)

        if (reward > 0){
            /*
            this.state.Lotto.getPastEvents('EventDraw', {fromBlock: 0, toBlock: 'latest'}, function(error, result){
              if (error)
                console.log('Error in myEvent event handler: ' + error);
              else
                console.log('myEvent: ' + JSON.stringify(result));
            })
            */

            let guess = Math.round(Math.random() * (this.state.Contract_info[index].Difficulty))
            let seed = Math.round(Math.random() * (this.state.Contract_info[index].Difficulty))
            await this.state.Lotto.methods.draw(index, guess, seed).send({from: this.state.account, value: drawPrice})
                                      .on('transactionHash', (hash) => {
                                          console.log('Tx hash: ', hash)
                                          //window.alert('Tx hash: ' + hash)
                                          })
                                      .on('confirmation', (confirmationNumber, receipt) => {
                                            console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                            
                                            if (this.state.Lotto.methods.drawable(index).call()){
                                                //window.alert('Sorry for no luck!')
                                                this.setState({Message:'Sorry for no luck!'})
                                                this.setState({MessageID: index})
                                            }
                                            else{
                                                //window.alert('Congrats! You win the prize!')
                                                this.setState({Message:'Congrats! You win the prize!'})
                                                this.setState({MessageID: index})
                                            }
                                      })
                                      .on('error', function (error) { 
                                        console.log("ERROR: ", error.message); 
                                        window.alert('Sorry for an unexpected error. Drawing is reverted for '+ intros[index])
                                        this.setState({Message:'Sorry for an unexpected error. Drawing is reverted!'})
                                        this.setState({MessageID: index})
                                      })
            
          }
        }
    }
    
    
  }

  async btnSponsorClick(index){
      console.log(index + " is clicked") //
      this.setState({Message:''})
      this.setState({MessageID: index})

      if (!this.state.ContractStatus){
        window.alert('Contract loading error! Please clean your wallet cache and try it again.')
        return
      }

      if (this.state.Lotto != null){
        const sponsorable = this.state.Contract_info[index].Sponsorable
        if (sponsorable === 'true'){
            if (window.confirm('Are you sure to be the dealer of < ' + intros[index] + '> ?')){ 
              const sponsorPrice = this.state.SponsorPrice // in wei
              console.log('sponsor price ' + index + ': ' + sponsorPrice * 1.0e-18)
              
              await this.state.Lotto.methods.becomeSponsor(index).send({from: this.state.account, value: sponsorPrice})
                                            .on('transactionHash', (hash) => {
                                                console.log('CREATING hash:', hash)
                                                //window.alert('Tx hash: ' + hash)
                                                })
                                            .on('confirmation', (confirmationNumber, receipt) => {
                                                  console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                                  
                                                  //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
                                                  this.setState({Message:'Congrats! You are dealer now and could win 50 ETH.'})
                                                  this.setState({MessageID: index})
                                            })
                                            .on('error', function (error) { 
                                              console.log("ERROR: ", error.message); 
                                              window.alert('Sorry for an unexpected error. Tx is reverted!')
                                              this.setState({Message:'Sorry for an unexpected error. Tx is reverted.'})
                                              this.setState({MessageID: index})
                                            })
                  
                }
          }else{
              window.alert('This painting is already sponsored! Please try others.')
          }
      }
    
  }


  async updateContractInfo(){
      if(!this.state.ContractStatus)
        return

      const Contract_info = []
      for (let i=0; i<Number(this.state.ItemNumber); i++) {
        const sponsorable = await this.state.Lotto.methods.sponsorable(i).call()
        const drawable = await this.state.Lotto.methods.drawable(i).call()
        const reward = await this.state.Lotto.methods.checkReward(i).call()
        const txNum = await this.state.Lotto.methods.getTxNum(i).call()
        const difficulty = await this.state.Lotto.methods.getDifficulty(i).call()
        const isOwner = await this.state.Lotto.methods.isOwner(this.state.account, i).call()

        Contract_info.push( {
              TxNum: Number(txNum.toString()),
              Sponsorable: sponsorable.toString(),
              Drawable: drawable.toString(),
              Reward: Number(reward.toString()),
              Difficulty: Number(difficulty.toString()),
              IsOwner: isOwner.toString(),
            }
          )
      }

      this.setState({Contract_info})

  }



  render() {
 

    return (
      <div>
        <nav className="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
          <a
            className="navbar-brand col-sm-3 col-md-2 mr-0"
            href="https://dappradar.com/app/1880/lucky-crypto-paintings"
            target="_blank"
            rel="noopener noreferrer"
          >
            Crypto Paintings
            
          </a>
        </nav>
        <div className="container-fluid mt-5">
          <div className="row">
            <main role="main" className="col-lg-12 d-flex text-center">
              <div className="content mr-auto ml-auto">
  
                <h1><img src={logo} className="App-logo" alt="logo" />     Lucky Crypto Paintings</h1>
                <hr/>
                <p align="left"><font size="5">Usage:</font></p>
                <p align="left"><font size="5">[1] As a dealer you could win up to 50ETH with 0.5ETH (x100): 1) bid to be owner; 2) ask others to draw; 3) if the prize in the pool reaches 50ETH, you win the prize.</font></p>
                <p align="left"><font size="5">[2] As a player you could win up to 50ETH with 0.1ETH (x500): just draw it with a chance to win the increasing prize in the pool.</font></p>
                <p align="left"><font size="4">Note: 1) the chance to win the prize decreases while the amount of the prize in the pool inreases; 2) you could be the dealer and player at the same time.</font></p>
                <hr/>
                <div className="Draw_Items"> 
                  <ul>
                      {this.state.Contract_info.map((contract, index)=> (
                            <p key={index}>
                              <span>&nbsp;&nbsp;</span>
                              <img src={img_srcs[index]} alt={index.toString()}/>
                              <li>{intros[index]}</li>
                              <span>&nbsp;&nbsp;</span>
                              <li>Draw Times: {this.state.ContractStatus ? contract.TxNum: 0}, ---- Lottery Drawable: {this.state.ContractStatus ? contract.Drawable: false}</li>
                              <li>Biddable: {this.state.ContractStatus ? contract.Sponsorable: false}, ---- You are owner: {this.state.ContractStatus ? contract.IsOwner: false}</li>
                              <li>Prize: {this.state.ContractStatus ? contract.Reward * 1.0e-18: 0} ETH, ---- Win Chance: 1/{this.state.ContractStatus ? contract.Difficulty: -1}</li>
                              <span>&nbsp;&nbsp;</span>
                              <li>Message: {this.state.MessageID === index && <p> {this.state.ContractStatus ? this.state.Message: "Please wait for loading ..."} </p>} </li>
                              <span>&nbsp;&nbsp;</span>
                              <li><button onClick={this.btnSponsorClick.bind(this, index)}>Bid to be owner</button></li>
                              <span>&nbsp;&nbsp;</span>
                              <li><button  onClick={this.btnDrawClick.bind(this, index)}>Draw to win</button></li>
                              <hr/>
                              <span>&nbsp;&nbsp;</span>
                            </p>
                      ))}
                    
                  </ul>
                </div>




              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
